<template>
  <div id="index">
    <section class="topCar">
      <!-- 顶部轮播 -->
      <section>
        <a class="contain" href="javascript:;">
          <slider ref="slider" :pages="pages" :sliderinit="sliderinit">
            <!-- <img src="/static/img/banner.png" alt=""> -->
          </slider>
        </a>
      </section>
    </section>
    <!--  中间导航栏 -->
    <nav>
      <div>
        <h3><span></span> <i></i> 我的住房 <span></span></h3>
        <ul class="first">
          <li class="repair" @click="repair"><a>报修</a></li>
          <li class="pay" @click="toPay"><a>缴费</a></li>
          <li class="toComplaint" @click="toComplaint"><a>投诉</a></li>
          <li class="complain" @click="complain"><a>建议</a></li>
        </ul>
      </div>
    </nav>
    <!--弹窗-->
    <div v-if="sec4" class="sec4"></div>
    <section v-if="popUp" class="popUp">
      <img @click="close" src="../../../static/img/close.png">
      <p v-if="pa" class="pa">您还未绑定手机号，请立即去绑定</p>
      <p v-if="pb" class="pb">您还没有房产信息，请点击获取房产或点击更换手机号</p>
      <div v-if="pa" class="diva">
        <input @click="bangDing" type="text" value="绑定">
      </div>
      <div v-if="pb" class="divb clear">
        <input @click="fangchanxinxi" class="float-f" type="text" value="同步房产">
        <input @click="bangDing" class="float-r" type="text" value="更换手机号">
      </div>
    </section>
    <!-- 底部导航栏 -->
    <footer>
      <ul>
        <li class="index"><a>首页</a></li>
        <!--<li class="open" @click="openNo"><a> <img src="/static/img/openDoor-new2.png"> 开门</a></li>-->
        <li class="mine" @click="toMy"><a>我的</a></li>
      </ul>
    </footer>
  </div>
</template>
<script>
  import slider from 'vue-concise-slider'

  export default {
    data() {
      return {
        sec4: false,
        popUp: false,
        pa: false,
        pb: false,
        pages: [
          // {html: '<img style="width:100%;" src="/static/img/banner.png" alt="">'},
          {html: '<img style="width:100%;height:100%;" src="/static/img/banner3.jpg" alt="">'},
          {html: '<img style="width:100%;height:100%;" src="/static/img/banner2.jpg" alt="">'},
        ],
//    animate: false,
//    marqueetimer: null,
        sliderinit: {
          currentPage: 0,
          thresholdDistance: 100,
          thresholdTime: 300,
          autoplay: 2000,
          loop: true,
          infinite: 1,
          slidesToScroll: 1,
          timingFunction: 'ease',
          duration: 500,
          typeNum: 0
        },

      }
    },
    components: {
      slider
    },
    created: function () {
      //setInterval(this.scroll, 2500)
    },
    methods: {
      close() {
        this.popUp = false
        this.sec4 = false
      },
      bangDing() {
        this.$router.push({name: 'checkTel'})
      },
      fangchanxinxi() {
        this.$router.push({name: 'houseInfo'})
      },
      initAddress() {
        const _this = this
        _this.postRequest('house/queryByUserId', {}, function (data) {
          if (data.length <= 0) {
            //弹窗
            _this.pb = true
            _this.popUp = true
            _this.sec4 = true
          } else {
            sessionStorage.setItem('el', data[0].name)
            sessionStorage.setItem('houseid', data[0].id)
            switch (_this.typeNum) {
              case 1:
                _this.$router.push({
                  // name: 'repair',
                  name: 'repairQingMeng',
                  params: {
                    house: data
                  }
                })
                break;
              case 2:
                _this.$router.push({
                  // name: 'complain',
                  name: 'adViseComlain',
                  params: {
                    house: data
                  }
                })
                break;
              case 3:
                _this.$router.push({
                  name: 'payXinYuan',
                  params: {
                    house: data
                  }
                })
                break;
              case 4:
                _this.$router.push({
                  name: 'complainQingMeng',
                  params: {
                    house: data
                  }
                })
                break;
            }
          }
        })
      },
      acquireIphone() {
        const _this = this
        _this.postRequest('user/currentUserDetail ', {}, function (data) {
          if (data.phone) {
            console.log('有手机号' + data.phone)
            _this.initAddress()
          } else {
            //弹窗
            _this.pa = true
            _this.popUp = true
            _this.sec4 = true
          }
        })
      },
      scroll() {
        this.animate = true
        setTimeout(() => {
          this.marqueeList.push(this.marqueeList[0])
          this.marqueeList.shift()
          this.animate = false
        }, 1500)
      },
      repair() {//报修
        this.typeNum = 1
        this.acquireIphone()
      },
      complain() {//投诉
        this.typeNum = 2
        this.acquireIphone()
      },
      toComplaint(){
        // complain 改为建议，toComplaint 投诉
        this.typeNum = 4;
        this.acquireIphone()
      },
      // 点击我的 跳转我的页面，获取关注的人的微信的信息包括 头像和昵称
      toMy() {//我的
        // this.$router.push({name: 'my'})
        this.$router.push({name: 'myXinYuan'})
      },
      comList() {
        this.$router.push({name: 'comList'})
      },
      toPay() {//缴费
        this.typeNum = 3
        this.acquireIphone()
      },
      toDetail() {
        this.$router.push({name: 'hotNoteDetail'})
      },
      // openNo() {
      //   alert('暂未开通，敬请期待')
      // }
    }
  }
</script>
<style scoped>
  /*遮罩样式*/
  .sec4 {
    width: 100%;
    height: 1334px;
    background: #000000;
    opacity: .4;
    z-index: 10;
    position: fixed;
    top: 0;
  }

  .clear {
    overflow: hidden;
    zoom: 1;
  }

  .float-f {
    float: left;
    width: 48%;
  }

  .float-r {
    float: right;
    width: 48%;
  }

  .popUp {
    z-index: 20;
    background: #fff;
    border-radius: 10px;
    width: 88%;
    height: 302px;
    position: fixed;
    top: 480px;
    left: 50%;
    transform: translateX(-50%);
  }

  .popUp img {
    width: 28px;
    height: 28px;
    margin-left: 620px;
    margin-top: 16px;
  }

  /*绑定弹框*/
  .popUp .pa {
    line-height: 70px;
    font-size: 28px;
    text-align: center;
  }

  .popUp .diva input {
    width: 38%;
    height: 68px;
    font-size: 30px;
    text-align: center;
    background: rgb(27, 130, 209);
    border-radius: 90px;
    color: #fff;
    margin: 60px 0 0 200px;
  }

  /*获取房产 和 更换手机号 弹框*/
  .popUp .pb {
    width: 75%;
    padding: 0 40px;
    text-align: center;
    margin: 30px 0;
    margin-left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
  }

  .popUp .divb {
    margin-top: -10px;
    margin: 0 50px;
  }

  .popUp .divb input {
    width: 38%;
    height: 68px;
    font-size: 30px;
    text-align: center;
    background: rgb(27, 130, 209);
    border-radius: 90px;
    color: #fff;
    margin: 10px 0;
  }

  /* 固定二倍图尺寸 */
  .more2 {
    width: 12px;
    height: 21px;
  }

  .fl {
    float: left;
  }

  #index {
    width: 100%;
    /*height: 100%;*/
    background-color: #EEEEEE;
  }

  /* 轮播图 */
  #index .topCar .contain {
    display: block;
    width: 100%;
    /* 原图尺寸750*366 */
    height: 334px;
  }

  /* 中间nav */
  #index nav {
    width: 100%;
    height: 510px;
    padding-bottom: 300px;
    /*margin-top: 10px;*/
    margin-bottom: 10px;
    background-color: #fff;
  }

  #index nav div {
    height: 334px;
    background-color: #fff;
    margin-bottom: 10px;
  }

  #index nav h3 {
    text-align: center;
    color: #03acfb;
    font-size: 27px;
    padding: 40px 0;
    box-sizing: border-box;
    /* line-height: 1; */
    /* height: 30px; */
    /* line-height: 30px; */
    display: flex;
    justify-content: center;
  }

  #index nav i {
    display: inline-block;
    width: 29px;
    height: 32px;
    background: url(/static/img/house.png) no-repeat;
    background-size: 25px 29px;
    background-position: 0px 5px;
    margin-right: 7px;
  }

  #index nav h3 span {
    display: inline-block;
    width: 75px;
    height: 2px;
    /* vertical-align: middle; */
    align-self: center;
    margin-left: 20px;
    margin-right: 20px;
    background-color: #03ACFB;
  }

  #index nav div .first {
    display: flex;
    padding-left: 48px;
    padding-right: 48px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-top: 20px;
    box-sizing: border-box;
  }

  /*图标下面的文字*/
  #index nav div .first li a {
    display: inline-block;
    width: 78px;
    height: 107px;
    padding-top: 35px;
    box-sizing: border-box;
    line-height: 177px;
    text-align: center;
    font-size: 32px;
  }

  #index nav div .first .repair a {
    background: url('/static/img/repair.png') no-repeat;
    background-size: 78px;
  }

  #index nav div .first .complain a {
    background: url('/static/img/complain.png') no-repeat;
    background-size: 78px;
  }

  #index nav div .first .pay a {
    background: url('/static/img/pay.png') no-repeat;
    background-size: 78px;
  }
  #index nav div .first .toComplaint a {
    background: url('../../../static/img/xinYuanComplain.png') no-repeat;
    background-size: 78px;
  }

  /*#index nav div .first .fixture a{
      background: url('/static/img/fixture.png')no-repeat;
      background-size: 65px;
  }*/
  #index nav div .two {
    display: flex;
    padding-left: 48px;
    padding-right: 48px;
    box-sizing: border-box;
    justify-content: space-between;
  }

  #index nav div .two li {
    /* display: flex; */
    /* justify-content: center; */
    /* width: 25%; */
    width: 67px;
    text-align: center;
  }

  #index nav div .two li a {
    display: inline-block;
    width: 67px;
    /* width: 100%; */
    height: 107px;
    line-height: 177px;
    background-size: 65px;
    padding-top: 5px;
    box-sizing: border-box;
    text-align: center;
  }

  #index nav div .two .express {
    background: url('/static/img/express.png') no-repeat;
    background-size: 65px;
    background-position: 0px 0px;
  }

  #index nav div .two .wjdc {
    position: relative;
    background: url('/static/img/wjdc.png') no-repeat;
    background-size: 65px;
    /* background-position: 40px 0; */
  }

  #index nav div .two .active {
    background: url('/static/img/active.png') no-repeat;
    background-size: 65px;
    position: relative;
    /* background-position: 60px 0; */
  }

  #index nav div .two .visitor {
    background: url('/static/img/visitor.png') no-repeat;
    background-size: 65px;
    /* background-position: 100px 0; */
  }

  #index nav div .two .wjdc a {
    text-align: left;
    position: absolute;
    left: -25px;

  }

  #index nav div .two .active a {
    position: absolute;
    left: 0px;
    top: 0;
  }

  /* 问卷调查部分  */
  #index nav div .two .wjdc a {
    width: 110px;
    text-align: center;
  }

  #index nav img {
    height: 165px;
  }

  /*test*/
  #index nav > a {
    display: inline-block;
    width: 200px;
    height: 50px;
    line-height: 50px;
    border: 1px solid #0000CC;
  }

  /* 热门帖子 */
  #index .hotNote {
    background-color: #fff;
  }

  #index .hotNote h3 {
    text-align: center;
    color: #03C58C;
    font-size: 27px;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    position: relative;
  }

  #index .hotNote h3 span {
    display: inline-block;
    width: 75px;
    height: 2px;
    /* vertical-align: middle; */
    align-self: center;
    margin-left: 20px;
    margin-right: 20px;
    background-color: #03C58C;
  }

  #index .hotNote h3 i {
    display: inline-block;
    width: 29px;
    height: 32px;
    background: url(/static/img/hot.png) no-repeat;
    background-size: 26px 26px;
    background-position: 0px 5px;
    margin-right: 7px;
  }

  #index .hotNote h3 a {
    /* margin-left: 50px; */
    vertical-align: middle;
    position: absolute;
    color: #999999;
    right: 30px;
  }

  #index .hotNote ul {
    padding-bottom: 98px;
    box-sizing: border-box;
  }

  #index .hotNote ul li {
    width: 100%;
    position: relative;
    height: 157px;
    margin-bottom: 30px;
    padding: 0 30px;
    box-sizing: border-box;
  }

  #index .hotNote ul li img {
    width: 176px;
    height: 156px;
    float: left;
  }

  #index .hotNote ul li .rigthDetail {
    width: 486px;
    height: 110px;
    position: relative;
    float: right;
    margin-top: 15px;
  }

  #index .hotNote ul li .rigthDetail .title {
    color: #666666;
    font-size: 25px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  /* 多行文本溢出省略号 */
  #index .hotNote ul li .rigthDetail .content {
    width: 100%;
    height: 82px;
    font-size: 25px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #666666;
    text-align: left;
  }

  #index .hotNote ul li .rigthDetail .title i {
    font-style: normal;
    font-size: 25px;
  }

  /* 底部导航栏 */
  #index footer {
    width: 100%;
    height: 98px;
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #fff;
    /* z-index: 1000; */
  }

  #index footer ul {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-between;
  }

  #index footer ul {
    border-top: 1px solid #eee;
  }

  #index footer ul li {
    width: 20%;
    float: left;
    height: 100%;
  }

  #index footer ul .open {
    border-top: 1px solid transparent;
  }

  #index footer ul li a {
    display: inline-block;
    width: 150px;
    height: 100%;
    line-height: 6;
    text-align: center;
    /* background: url('/static/img/homePage-old.png')no-repeat; */
    background-size: 36px 36px;
    background-position: 55px 15px;
  }

  /*首页两个字*/
  #index footer ul .index a {
    background: url('/static/img/homePage-new.png') no-repeat;
    background-size: 36px 36px;
    background-position: 57px 15px;
    color: #1B82D1;
  }

  #index footer ul .open a {
    position: relative;
    color: #999;
  }

  #index footer ul .open a img {
    display: inline-block;
    width: 42px;
    height: 45px;
    border-radius: 30px;
    position: absolute;
    left: 55px;
    top: 13px;
  }

  #index footer ul .mine a {
    background: url('/static/img/mine-old.png') no-repeat;
    background-size: 36px 36px;
    background-position: 55px 15px;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/components/wanTong/homePage-wanTong.vue